import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  > button:first-child {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 10;
  }
`;

export const Body = styled.div`
  padding: 1rem;
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

  &::-webkit-scrollbar {
    border-radius: 10px;
    height: 11px;
    width: 11px;
    border: 1px solid ${({ theme }) => theme.palette.grey._300.hex()};
    background-color: ${({ theme }) => theme.palette.grey._425.hex()};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.blue._400.hex()};
  }
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

export const Footer = styled.footer`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 2rem;
`;

export const Text = styled.p`
  width: 100%;
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  color: #000000;
  margin: 0;
`;

export const Title = styled.h2`
  width: 100%;
  text-align: left;
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.blue._970.hex()};
  margin: 0;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 0;
  button {
    width: 100%;
    padding: 0.75rem 1rem;
  }
`;

export const Button = styled.button`
  border: none;
  outline: none;
  background: #080e32;
  border-radius: 32px;
  width: 94px;
  height: 24px;
  color: #ffffff;
`;

export const Rounded = styled.button`
  width: 16px;
  height: 16px;
  background: #fc6058;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  a {
    color: #0055ff;
    text-decoration: none;
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
  }

  svg {
    color: #0055ff;
  }
`;
